<template>
  <div>
    <form-wizard
      color="#0080C9"
      :title="null"
      :subtitle="null"
      layout="horinzotal"
      finish-button-text="Crear"
      back-button-text="Retroceder"
      next-button-text="Siguiente"
      class="wizard-vertical mb-3"
      @on-complete="formSubmittedDoctor"
      @before-change="beforeStepChange"
    >
      <!-- información general del doctor -->
      <tab-content 
        title="Información del doctor." 
        :before-change="validationFormInfo"
      >
        <validation-observer ref="infoRules" tag="form">
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Información del doctor.
              </h5>
              <small class="text-muted">
                Ingresa la información del doctor.
              </small>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-tipo-ident">
                <label>Tipo Identificación: <span class="text-danger">*</span></label>
                <validation-provider 
                  v-slot="{ errors }" 
                  name="tipoIdent" 
                  rules="required"
                >
                  <b-form-select
                    id="v-type-ident"
                    v-model="tipoIdent"
                    :options="opsTipoIdent"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="mc-identificacion">
                <label>Identificación: <span class="text-danger">*</span></label>
                <validation-provider
                  v-slot="{ errors }"
                  name="identificacion"
                  :rules="identificacionRules">
                  <b-form-input
                    id="mc-identificacion"
                    v-model="identificacion"
                    placeholder="0999999999"
                    name="identificacion"
                    
                    type="text"
                    :maxlength="maxInputLength"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
          
            <b-col md="6">
              <b-form-group label-for="v-lastname">
                <label>Apellidos: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="apellido" rules="required">
                  <b-form-input id="v-lastname" :state="errors.length > 0 ? false : null" v-model="apellidod" type="text"
                    placeholder="Escriba su apellido" />
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-name">
                <label>Nombres: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="nombre" rules="required">
                  <b-form-input id="v-name" :state="errors.length > 0 ? false : null" v-model="nombred" type="text"
                    placeholder="Escriba su nombre" />
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label-for="v-datebirth">
                <label>Fecha de nacimiento: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }"  name="fechaNacimiento" rules="required">
                  <div class="flatpickr-container">
                    <flat-pickr v-model="fechaNacimiento" :state="errors.length > 0 ? false : null" locale="es" :config="birthDateConfig">
                    </flat-pickr>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-fechainicio">
                <label>Fecha de ingreso: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }"  name="fechaInicioDoctor" rules="required">
                  <div class="flatpickr-container">
                    <flat-pickr id="v-fechainicio" v-model="fechaInicioDoctor"  :state="errors.length > 0 ? false : null" locale="es" :config="birthDateConfig">
                    </flat-pickr>
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label-for="v-cell">
                <label>Celular: <span class="text-danger">*</span></label>
                <validation-provider
                  v-slot="{ errors }"
                  name="celular"
                  rules="required"
                >

                  <b-form-tags
                    id="v-cell" 
                    input-id="tags-validation"
                    v-model="celular"
                    :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
                    :tag-validator="tagValidator"
                    :state="errors.length > 0 ? false : null"
                    separator=" "
                    input-type="number"
                    placeholder="099999999"
                  />

                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group
                label-for="mc-email"
              >
                <label>Correo eletrónico: <span class="text-danger">*</span></label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Correo eletrónico"
                  rules="required|email"
                >
                  <b-form-input
                    id="mc-email"
                    v-model="email"
                    placeholder="ana@example.com"
                    name="email"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
            <b-col md="6">
              <b-form-group label-for="v-reg-senn">
                <label>Número de registro de Sennecyt: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="numeroregistrosenescypt" rules="required">
                  <b-form-input 
                    id="v-reg-senn" :state="errors.length > 0 ? false : null" type="text" 
                    placeholder="5465-4654-64654" 
                    v-model="numeroregistrosenescyt" 
                    maxlength="80"
                    pattern="[0-14]{15}" title="Ingresa número de registro Sennecyt" />
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label-for="v-tipodoctor">
                <label>Tipo de Doctor: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="tipodoctor" rules="required">
                  <v-select 
                    id="v-tipodoctor" 
                    v-model="tipodoctor" 
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                    :options="opsTipoDoctor"
                    label="text"
                    value="value" 
                    :class="{ 'is-invalid': errors.length > 0 }" 
                  />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group  label-for="v-especialidad">
                <label>Especialidad: <span class="text-danger">*</span></label>
                <validation-provider v-slot="{ errors }" name="especialidad" rules="required">
                  <v-select id="v-especialidad" v-model="especialidad" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="opsEspecialidad" :selectable="option => !option.value.includes('select_value')"
                            label="text" :class="{ 'is-invalid': errors.length > 0 }" />
                  <div v-if="errors.length > 0" class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </b-form-group>
            </b-col>
        

          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content title="Horario" :before-change="validationHorario">
        <DoctorHorarioForm v-model="horariosDoctor" :turno.sync="turnoMinutos" />
      </tab-content>

      <!-- documentos -->
      <tab-content title="Documentos" :before-change="validationFormDocu">
        <validation-observer ref="docuRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Documentos</h5>
              <small class="text-muted">Agregar los documentos necesarios</small>
            </b-col>
          </b-row>
          <b-row>

            <b-card class="col-12" style="border: 1px solid #c9c9c9">

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Titulo</h6>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.titulo"
                  :state="Boolean(uploads.titulo)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  accept=".pdf"
                />
              </div>

              <hr>

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Firma</h6>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.firma"
                  :state="Boolean(uploads.firma)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  @change="validarArchivo($event, 'firma')"
                  accept=".png,.jpg,.jpeg"
                />
              </div>

              <hr>

              <div class="row d-flex align-items-center my-2">
                <h6 class="col-2">Firma y Sello</h6>

                <b-form-file
                  class="col-6 offset-1"
                  v-model="uploads.sello"
                  :state="Boolean(uploads.sello)"
                  placeholder="elija un archivo o arrastre aqui..."
                  drop-placeholder="Drop file here..."
                  browse-text="Buscar..."
                  @change="validarArchivo($event, 'sello')"
                  accept=".png,.jpg,.jpeg"
                />
              </div>

            </b-card>
          </b-row>
        </validation-observer>
        
      </tab-content>

    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect                    from 'vue-select'
import { required,  email }       from '@validations'
import rutas                      from '@/assets/utils/rutas.json';
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import flatPickr                  from 'vue-flatpickr-component';
import { BootstrapVue }           from 'bootstrap-vue';
import { fileService }            from '@/shared/services';
import 'flatpickr/dist/flatpickr.css';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'


import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios';
import Swal from 'sweetalert2'
import DoctorHorarioForm from './components/DoctorHorarioForm.vue';

const DAYS_ORDER = [
  { key: 'monday', value: 1, label: 'Lunes' },
  { key: 'tuesday', value: 2, label: 'Martes' },
  { key: 'wednesday', value: 3, label: 'Miércoles' },
  { key: 'thursday', value: 4, label: 'Jueves' },
  { key: 'friday', value: 5, label: 'Viernes' },
  { key: 'saturday', value: 6, label: 'Sábado' },
]

const getDefaultHorario = () => ({
  monday: { enabled: false, start: null, end: null },
  tuesday: { enabled: false, start: null, end: null },
  wednesday: { enabled: false, start: null, end: null },
  thursday: { enabled: false, start: null, end: null },
  friday: { enabled: false, start: null, end: null },
  saturday: { enabled: false, start: null, end: null },
})

export default {
  components: {
    ...BootstrapVue.components,
    FormWizard,
    TabContent,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    DoctorHorarioForm,
  },
  data() {
    return {

      uploads: {
        titulo:null,
        firma:null,
        sello:null
      },

      horariosDoctor: getDefaultHorario(),
      turnoMinutos: 20,

      impedirAvance: false,
      idPersona: null,
      identificacionrepetida: false,
      identificaciones : null,
      email,
      required,
      nombred:null,
      apellidod:null,
      numeroregistrosenescyt:null,
      fechaInicioDoctor:null,
      especialidad:null,
      especialidadDescripcion:null,
      itemDoc:null,
      sexo:null,
      identificacion:null,
      tipo:null,
      email:null,
      celular:null,
      tipoIdent:null,
      urlTituloSenescyt:null,
      urlP12FirmaElectronica:null,
      idPerDoc:null,
      urlFirmaSello:null,
      urlTituloDoc:null,
      establecimiento:null,
      opsEstabSalud : [],
      items: [
        {
          documento: "Titulo Sennecyt",
          urldni: [],
          computedPlaceholder: "computedPlaceholderTit"
        },
        {
          documento: "Firma Doctor",
          urldni: [],
          computedPlaceholder: "computedPlaceholderFirm"
        },
        {
          documento: "Firma y Sello Doctor",
          urldni: [],
          computedPlaceholder: "computedPlaceholderFirmSello"
        }
        
      ],
      fields: [
        { key: 'documento', label: 'Documento', thClass: 'text-center' },
        { key: 'cargar', label: 'Cargar Cedula', thClass: 'text-center' }
      ],
      opsTipoIdent: [
        { value: '0', text: 'RUC' },
        { value: '1', text: 'Cedula' },
        { value: '2', text: 'Passporte' }
      ],
      opsSexo: [
        { value: '0', text: 'Masculino' },
        { value: '1', text: 'Femenino' }
      ],
      opsEspecialidad: [],
      opsTipoDoctor: [],
      tipodoctor:null,
      titsen:null,
      firdoc:null,
      firSelloDoc:null,
      tipoIdentValidation: null,
      tipoIdentErrors: [],
      identificacionValidation: null,
      identificacionErrors: [],
      fechaNacimiento:'',
      flatpickrConfig: {
        altInput: true, // Muestra un campo de entrada de texto adicional
        altFormat: 'd/m/Y', // Formato para el campo de entrada de texto
        dateFormat: 'Y-m-d', // Formato de fecha para el componente
        locale: {
          firstDayOfWeek: 1, // Lunes como primer día de la semana
        },
        enable: [
          {
            from: new Date(1900, 0, 1), // Establece la fecha mínima permitida
            to: new Date(), // Establece la fecha máxima permitida (hoy)
          },
        ],
      },
      birthDateConfig: {
        allowInput: true
      },
    }
  },
  created() {// aqui se colocan las funciones que aparezcan cargadas cuando se haga un post o un f5 de la misma.
    this.fetchTipos();
    this.fetchEspecilidades();
    this.fetchEstablecimientos();
    this.setToken();
    this.beforeStepChange();
    this.getComputedPlaceholder("3");
  },

  computed: {
    identificacionRules() {
      // Reglas de validación dinámicas basadas en el tipo de identificación
      if (this.tipoIdent === '1')
        return 'required|integer|digits:10';
      
      if (this.tipoIdent === '0')
        return 'required|integer|digits:13';
      
      if (this.tipoIdent === '2') 
        return 'required'; // Para Pasaporte (números y letras)

      return null;
    },
    inputType() {
      if (this.tipoIdent === '2') {
        return 'text'; // Pasaporte
      } else {
        return 'number'; // Cédula o RUC
      }
    },
    maxInputLength() {
      if (this.tipoIdent === '1') {
        return 10; // Cedula
      } else if (this.tipoIdent === '0') {
        return 13; // RUC
      } else {
        return 10; // Pasaporte
      }
    },
  


  },
  watch:{
    identificacion: async function(newVal) {
      if (newVal.length > 9) {
        let timerInterval;
        await this.fetchPersonas(this.identificacion)
        
        if(this.identificaciones && this.identificaciones.includes(newVal)){
          this.identificacionrepetida = true

          Swal.fire({
            title: "Cargando...",
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              timerInterval = setInterval(() => {
                const timer = Swal.getTimerLeft();
                if (timer) {
                  Swal.getContent().querySelector("b").textContent = `${timer}`;
                }
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            }
          });

          const doctorExistente = await this.fetchDoctores(newVal);
          const personaRepetida = await this.encontrarPersona(newVal);

          if (doctorExistente) {
            Swal.close();

            await this.$swal.fire({
              icon : "info",
              text : "Doctor encontrado. Desea actualizar el doctor?",
              showCancelButton: true,
              confirmButtonText: 'Sí',
              cancelButtonText: 'No',
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({name : 'editar_doctor', params : { token : doctorExistente}})
              } else { this.impedirAvance = true}
            });

            return

          }        
      
          

          else if (!doctorExistente && personaRepetida) {
            this.idPersona = personaRepetida.id
            this.apellidod = personaRepetida.primerApellido || ''
            this.nombred = personaRepetida.primerNombre || ''
            this.tipoIdent = personaRepetida.tipoIdentificacion || ''
            this.identificacion = personaRepetida.identificacion || ''
            this.email = personaRepetida.correo || ''
            this.fechaNacimiento = personaRepetida.fechaNacimiento || ''
            this.celular = personaRepetida.telefono || ''

          Swal.close();
          }   
        }else{
          Swal.close();
          this.$toast.success("Identificacion correcta");
          this.identificacionrepetida = false
        }
      }
    },

    tipoIdent(newTipoIdent) {
      this.tipoIdentValidation = null;
      this.tipoIdentErrors = [];
      this.identificacionValidation = null;
      this.identificacionErrors = [];
    },
  },
  methods: {
    validarArchivo(event, target) {
    const archivo = event.target.files[0];
    if (!archivo) return;

    const tipoValido = ['image/png', 'image/jpg', 'image/jpeg'];
    if (!tipoValido.includes(archivo.type)) {
      if (target == 'firma') {this.uploads.firma = ''}
      if (target == 'sello') {this.uploads.sello = ''}
   
      
      this.$swal.fire({
        title:'Ups',
        icon:'error',
        text:'No se permiten archivos diferentes a jpg, png o jpeg',
        timer:15000
      }
      )
      // this.$bvToast.toast('Solo se permiten archivos .jpg, .jpeg o .png', {
      //   title: 'Archivo no válido',
      //   variant: 'danger',
      //   solid: true
      // });
    }
  },
    async fetchDoctores(nombre) {
      const query = `
        query MyQuery($search: String) {
          allDoctores(search: $search) {
            status
              total
            message
            doctor {
              token
              id
            }
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables: { search: nombre } });

        const doctor = response.data.data.allDoctores.doctor;

        if (doctor && doctor.length > 0) {
        return doctor[0].token
          
        } else { return null }
      } catch (error) {
        console.error("Error buscando doctores:", error.response ? error.response.data : error.message);
      }
    },


    async actualizarPersona() {
      const argPacPer = {
        idPersona: this.idPersona.toString() || '',
        tipoIdentificacion: this.tipoIdent || '',
        identificacion: this.identificacion || '',
        apellidos: this.apellidod || '',
        nombres: this.nombred || '',
        fechaNacimiento: this.fechaNacimiento || '',
        nacionalidad: '',
        sexo: this.sexo || '',
        telefono: this.celular?.join() || '',
        estadoCivil: '',
        email: this.email || '',
        nivelEducacion: '',
        profesion: '',
        puebloKichwa: '',
        nacionalidadEtnica: '',
        esDiscapacitado: 0,
        urlIdentificacion: '',
        urlCarnet: '',
        pais: '',
        canton: '',
        parroquia: '',
        barrio: '',
        callePrincipal: '',
        calleSecundaria: '',
        referencia: '',
      };

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query: `
            mutation actualizarPersonaMut (
              $tipoIdentificacion: String!,
              $identificacion: String!,
              $apellidos: String!,
              $nombres: String!,
              $fechaNacimiento: String!,
              $nacionalidad: String,
              $sexo: String!,
              $telefono: String!,
              $estadoCivil: String,
              $email: String!,
              $nivelEducacion: String,
              $profesion: String,
              $puebloKichwa: String,
              $nacionalidadEtnica: String,
              $esDiscapacitado: Int,
              $pais: String,
              $canton: String,
              $parroquia: String,
              $barrio: String,
              $callePrincipal: String,
              $calleSecundaria: String,
              $referencia: String,
              $urlIdentificacion: String,
              $urlCarnet: String,
              $idPersona: String!,
            ){
              actualizarPersona(
                tipoIdent: $tipoIdentificacion
                identificacion: $identificacion
                apellidos: $apellidos
                nombres: $nombres
                fechaNacimiento: $fechaNacimiento
                nacionalidad: $nacionalidad
                sexo: $sexo
                telefono: $telefono
                estadoCivil: $estadoCivil
                email: $email
                nivelEducacion: $nivelEducacion
                profesion: $profesion
                pueKichwa: $puebloKichwa
                nacioEtni: $nacionalidadEtnica
                esDiscapacitado: $esDiscapacitado
                pais: $pais
                canton: $canton
                parroquia: $parroquia
                barrio: $barrio
                callePrincipal: $callePrincipal
                calleSecundaria: $calleSecundaria
                referencia: $referencia
                urlIdentificacion: $urlIdentificacion
                urlCarnet: $urlCarnet    
                idPersona: $idPersona
              ){
                persona {
                  token
                  id
                }
                status
                message
              }
            }
          `,
          variables: argPacPer,
        });

        if (response.status === 200 && response.data.data.actualizarPersona.status === 'success') {
          const { id } = response.data.data.actualizarPersona.persona;
          return { id: id.toString() };
        }
        throw new Error(response.data.data.actualizarPersona.message || 'Error al actualizar persona');
      } catch (err) {
        console.error('Error en actualizarPersona:', err);
        throw err;
      }
    },


    async encontrarPersona(search = '', contactPaciente = false) {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id
            fechaNacimiento
            sexo
            segundoApellido
            segundoNombre
            tipoIdentificacion
            estadoCivil
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { search }
        });

        if (contactPaciente) {
          const persona = response.data.data.allPersona[0]
          this.identificacionCont = persona.identificacion
        }

        const personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        return response.data.data.allPersona[0]

      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    async buscarPersonas( ){
      let timerInterval;
      if(this.identificacion && this.identificacion.length > 5 ){
        
        Swal.fire({
          title: "Cargando...",
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              const timer = Swal.getTimerLeft();
              if (timer) {
                Swal.getContent().querySelector("b").textContent = `${timer}`;
              }
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          }
        });
        // await this.fetchPersonas(this.identificacion)
          
        Swal.close();
      }
    },


    async fetchPersonas(search) {
      const query = `
        query MyQuery($search: String) {
          allPersona(search: $search) {
            correo
            telefono
            identificacion
            primerApellido
            primerNombre
            primerApellido
            id  
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: { search }
        });

        const personas = response.data.data.allPersona;
        const identificaciones = [];
        personas.forEach(persona => {
          identificaciones.push(persona.identificacion);
        });

        this.identificaciones = identificaciones
      
      } catch (error) {
        console.error("Error buscando personas:", error.response ? error.response.data : error.message);
      }
    },

    
    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsEstabSalud = response.data.data.allEstablecimientos.map(item => ({
          value: item.id,
          text: item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },


    tagValidator(tag) {
      const isValid = /^\d+$/.test(tag) && tag.length < 11
      this.tagError = isValid ? '' : 'Solo se permiten valores numéricos hasta de 10 caracteres'
      return isValid
    },

    async handleFileUpload(item, event) {
      const file = event.target.files[0];
      // upload the file and get the URL
      const url = await this.uploadFile(file); // assuming uploadFile is a function that uploads the file and returns the URL
      if (item.documento === "Titulo Sennecyt") {
        this.titsen = url;
      } else if (item.documento === "Firma Doctor") {
        this.firdoc = url;
      } else if (item.documento === "Firma y Sello Doctor") {
        this.firSelloDoc = url;
      } 
    },


    getComputedPlaceholder(type) {
      if (type === "computedPlaceholderTit") {
        return this.titsen;
      } else if (type === "computedPlaceholderFirm") {
        return this.firdoc;
      }else if (type === "computedPlaceholderFirmSello") {
        return this.firSelloDoc;
      } else {
        return "Agregar Cédula";
      }
    },
    async uploadFile(file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        const response = await axios.post(rutas.axios +'/api/upload/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        if(response.data.url){
          this.$swal({
            title: 'Imagen Cargada',
            text: 'Se ha cargado la imagen al servidor',
            icon: 'success',
            confirmButtonText: 'Entendido'
          });
          return response.data.url; // Assuming the backend sends the URL in the "url" key of the response
        }else{
          this.$swal({
            title: 'Error al cargar',
            text: 'No se ha cargado la imagen',
            icon: 'error',
            confirmButtonText: 'Entendido'
          })
          return '';
        }
      }catch(error) {
        console.log('File upload failed:', error);
      };
    },
   

    beforeStepChange(newStep, oldStep, prevent) {
      if (newStep > oldStep) {
        prevent();
      }
    },
    
    
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    async formSubmittedDoctor() {

      let loadingModalVisible = true;
    
      const loadingSwal = this.$swal({
        title: 'Guardando.. Por favor espere...',
        icon: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });

      try {
        const idDoctor = await this.crearDoctor();
        if (idDoctor > 0) {
          const horariosRegistrados = await this.guardarHorarioDoctor(idDoctor);
          if (!horariosRegistrados) {
            throw new Error('No se pudo registrar el horario del doctor');
          }

          loadingModalVisible = false;
          loadingSwal.close();
          this.$swal({
            title: 'Info',
            text: 'TODO CORRECTO',
            icon: 'success',
            confirmButtonColor: '#089599',
          })
          this.$router.push({ name: 'consultar_doctor' })
        } else {
          this.$swal({
            title: 'Error',
            text: 'Vuelva a intentarlo más tarde',
            icon: 'error',
            confirmButtonColor: '#089599',
          })
        }
      } catch (err) {
          
        loadingModalVisible = false;
        loadingSwal.close();

        console.log('Error DOCTOR create process:', err)
        this.$swal({
          title: 'Error',
          text: 'Error en crear DOCTOR: ' + err,
          icon: 'error',
          confirmButtonColor: '#089599',
        })
      } finally {
        
        if (loadingModalVisible) {
          loadingSwal.close();
        }
      }
      
    },
  
    async fetchEspecilidades() {
      const query = `
        query {
          allEspecialidad {
            id
            descripcion
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsEspecialidad = response.data.data.allEspecialidad.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        
        console.error("Error fetching especialidades:", error.response.data);
      }
    },
    async fetchTipos() {
      const query = `
        query {
          allTipomedico {
            id
            descripcion
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.opsTipoDoctor = response.data.data.allTipomedico.map(item => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        
        console.error("Error fetching tipo doctor:", error.response.data);
      }
    },


    validationFormInfo() {
      return new Promise((resolve, reject) => {
        if(this.identificacionrepetida && this.impedirAvance) {
          this.$swal({
            title: 'Identificacion ya existente!',
            text: 'Por favor ingresar una identificacion distinta',
            icon: 'error',
            confirmButtonText: 'Entendido'
          })
          reject()
        }
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
          
            this.$swal({
              title: 'Campos vacíos',
              text: 'Llenar todos los campos',
              icon: 'error',
              confirmButtonText: 'Entendido'
            })
            reject()
          }
        })
      })
    },


    validationFormDocu() {

      if(!this.uploads.firma || !this.uploads.sello){
        this.$swal({
          title: 'Campos vacíos',
          text: 'La firma y el sello son obligatorios',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });

        return false
      }

      return true
    },

    validationHorario() {
      const horarios = this.buildHorarioPayload();

      if (!horarios.length) {
        this.$swal({
          title: 'Horario incompleto',
          text: 'Seleccione al menos un día con un horario válido.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      if (!this.turnoMinutos) {
        this.$swal({
          title: 'Duración de turnos',
          text: 'Seleccione la duración de los turnos.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      const invalidRange = horarios.some(horario => !this.isTimeRangeValid(horario.hora_inicio, horario.hora_fin));

      if (invalidRange) {
        this.$swal({
          title: 'Horario inválido',
          text: 'Verifique que la hora de inicio sea menor que la hora de fin.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return false;
      }

      return true;
    },
  
    showToastSuccess() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Cita Creada',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },

    buildHorarioPayload() {
      const horarios = [];
      DAYS_ORDER.forEach(day => {
        const data = this.horariosDoctor[day.key];
        if (!data || !data.enabled) return;
        if (!data.start || !data.end) return;

        horarios.push({
          dia: day.value,
          hora_inicio: data.start,
          hora_fin: data.end,
          duracion: Number(this.turnoMinutos),
        });
      });

      return horarios;
    },

    isTimeRangeValid(start, end) {
      if (!start || !end) return false;
      const [startH, startM] = start.split(':').map(Number);
      const [endH, endM] = end.split(':').map(Number);
      return (startH * 60 + startM) < (endH * 60 + endM);
    },

    async guardarHorarioDoctor(doctorId) {
      const horarios = this.buildHorarioPayload();
      const query = `
        mutation SetHorarioDoctor($doctorId: String!, $horarios: String!) {
          setHorarioDoctor(doctorId: $doctorId, horarios: $horarios) {
            status
            message
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', {
          query,
          variables: {
            doctorId: String(doctorId),
            horarios: JSON.stringify(horarios),
          },
        });

        const payload = response.data.data?.setHorarioDoctor;
        if (!payload || payload.status !== 'success') {
          throw new Error(payload?.message || 'No fue posible guardar el horario del doctor');
        }

        return true;
      } catch (error) {
        console.error('Error al guardar horario del doctor:', error);
        this.$swal({
          title: 'Error',
          text: error.message || 'Error al guardar el horario del doctor',
          icon: 'error',
          confirmButtonColor: '#089599',
        });
        return false;
      }
    },

    async crearDoctor() {
      try {
        let responsePersona = null;

        // Caso 1: Persona existente (this.idPersona está definido)
        if (this.idPersona) {
          responsePersona = { id: this.idPersona.toString() }; // Convertir a objeto
        } 
        // Caso 2: Persona no existente, crearla
        else {
          const argDoctor = {
            nombres: this.nombred || '',
            apellidos: this.apellidod || '',
            nacioEtni: '',
            ...(this.tipoIdent ? { tipoIdent: this.tipoIdent } : { tipoIdent: '' }),
            identificacion: this.identificacion || '',
            telefono: this.celular?.join(',') || '',
            email: this.email || '',
            fechaNacimiento: this.fechaNacimiento || '',
            nacionalidad: '',
            nivelEducacion: '',
            profesion: '',
            pueKichwa: '',
            tipoBono: '',
            idbarrio: '1',
            cprincipal: '...',
            csecundaria: '',
            referenciasect: '',
            urlIdentificacion: '',
            esDiscapacitado: 0,
            urlCarnet: '',
          };

          // Validar campos requeridos para crear persona
          if (!argDoctor.nombres || !argDoctor.apellidos || !argDoctor.identificacion || !argDoctor.tipoIdent) {
            throw new Error('Faltan campos obligatorios para crear la persona');
          }

          responsePersona = await this.crearPersona(argDoctor);
        }

        // Validar que responsePersona tenga un id válido
        if (!responsePersona || !responsePersona.id) {
          throw new Error(
            `No se pudo obtener el ID de la persona. ResponsePersona: ${JSON.stringify(responsePersona)}`
          );
        }

        // Subir archivos (título, firma, sello) si existen
        let urlTitulo = null;
        let urlFirma = null;
        let urlSello = null;

        if (this.uploads?.titulo) {
          urlTitulo = await fileService.upload('titulos', this.uploads.titulo, this.identificacion);
        }

        if (this.uploads?.firma) {
          urlFirma = await fileService.upload('firmas', this.uploads.firma, this.identificacion);
        }

        if (this.uploads?.sello) {
          urlSello = await fileService.upload('sellos', this.uploads.sello, this.identificacion);
        }

        // Preparar argumentos para crear el doctor
        const argDoc = {
          idPersona: responsePersona.id,
          especialidad: this.especialidad ? this.especialidad.value : '',
          urlTitulo: urlTitulo || '',
          urlFirma: urlFirma || '',
          urlSello: urlSello || '',
          numeroregistrosenescyt: this.numeroregistrosenescyt || '',
          fechaInicioDoctor: this.fechaInicioDoctor || '',
          tipomedico: this.tipodoctor?.value || '',
        };

        // Validar campos requeridos para crear el doctor
        if (
          !argDoc.idPersona ||
          !argDoc.especialidad ||
          !argDoc.numeroregistrosenescyt ||
          !argDoc.fechaInicioDoctor ||
          !argDoc.tipomedico
        ) {
          throw new Error('Faltan campos obligatorios para crear el doctor');
        }

        // Consulta GraphQL para crear el doctor
        const response = await axios.post(rutas.axios + 'api', {
          query: `
            mutation crearDoctor (
              $idPersona: String!,
              $especialidad: String!,
              $numeroregistrosenescyt: String!,
              $urlTitulo: String,
              $urlFirma: String,
              $urlSello: String,
              $fechaInicioDoctor: String!,
              $tipomedico: String!
            ) {
              crearDoctor(
                idPersona: $idPersona
                especialidad: $especialidad
                numeroregistrosenescyt: $numeroregistrosenescyt
                fechaInicioDoctor: $fechaInicioDoctor
                urlTituloSenescyt: $urlTitulo
                urlP12FirmaElectronica: $urlFirma
                urlFirmaSello: $urlSello
                tipomedico: $tipomedico
              ) {
                doctor {
                  token
                  id
                }
                status
                message
              }
            }
          `,
          variables: argDoc,
        });

        console.log('Response crear doctor:', response);

        // Manejar la respuesta
        if (response.status === 200 && response.data.data.crearDoctor.status === 'success') {
          this.$swal({
            title: 'Éxito',
            text: response.data.data.crearDoctor.message || 'Doctor creado correctamente',
            icon: 'success',
            confirmButtonColor: '#089599',
          });
          return response.data.data.crearDoctor.doctor.id;
        } else {
          this.$swal({
            title: 'Error',
            text: response.data.data.crearDoctor.message || 'Error al crear el doctor',
            icon: 'error',
            confirmButtonColor: '#089599',
          });
          return null;
        }
      } catch (err) {
        console.error('Error en el proceso de creación del doctor:', err);
        this.$swal({
          title: 'Error',
          text: `Error al crear el doctor: ${err.message}`,
          icon: 'error',
          confirmButtonColor: '#089599',
        });
        return null;
      }
    },

    async crearPersona(argPersona) {
      const query = `
        mutation crearPersona (
          $nombres: String!,
          $apellidos: String!,
          $tipoIdent: String!,
          $identificacion: String!,
          $telefono: String!,
          $fechaNacimiento: String!,
          $email: String!,
          $nacionalidad: String,
          $nivelEducacion: String,
          $profesion: String,
          $pueKichwa: String,
          $tipoBono: String,
          $nacioEtni: String,
          $cprincipal: String,
          $csecundaria: String,
          $referenciasect: String,
          $idbarrio: String,
          $urlIdentificacion: String,
          $urlCarnet: String,
          $esDiscapacitado: Int
        ) {
          crearPersona(
            nombres: $nombres
            apellidos: $apellidos
            tipoIdent: $tipoIdent
            identificacion: $identificacion
            telefono: $telefono
            fechaNacimiento: $fechaNacimiento
            email: $email
            nacionalidad: $nacionalidad
            nivelEducacion: $nivelEducacion
            profesion: $profesion
            pueKichwa: $pueKichwa
            tipoBono: $tipoBono
            nacioEtni: $nacioEtni
            callePrincipal: $cprincipal
            calleSecundaria: $csecundaria
            referencia: $referenciasect
            barrio: $idbarrio
            urlIdentificacion: $urlIdentificacion
            urlCarnet: $urlCarnet
            esDiscapacitado: $esDiscapacitado
          ) {
            persona {
              token
              id
            }
            status
            message
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables: argPersona });
        console.log('Crear persona response:', response);

        if (response.status === 200 && response.data.data.crearPersona.status === 'success') {
          const { id, token } = response.data.data.crearPersona.persona;
          return { id: id.toString(), token };
        }
        throw new Error(response.data.data.crearPersona.message || 'Error al crear persona');
      } catch (err) {
        console.error('Error en crearPersona:', err);
        throw err;
      }
    }

  },
}
</script>

<style>
  .my-icon-link {
    margin-right: 10px;
    padding-left: 500px;
  }
  .flatpickr-container input {
    padding: 0.438rem 1rem;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    display: block;
    width: 100%;
    height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
</style>
